(() => {
  const FORCE_MS = 2000;
  const FADE_MS = 700;

  /** Orden de siluetas del catálogo (mismo que chips TODOS — no A–Z) */
  const SIL_ORDER = [
    'barrel', 'basic', 'biker', 'bota-campana', 'boyfriend', 'cargo', 'camisa',
    'enterizo', 'falda-exclusive', 'flare', 'jort', 'mom-fit', 'palazzo',
    'pantalon', 'short', 'torero-maxi', 'wide-leg', 'bermuda', 'jean',
    'jogger', 'skinny', 'slim'
  ];

  function genderOf(el) {
    return String(el.dataset.gender || '').toLowerCase().trim();
  }

  function silOf(el) {
    return String(el.dataset.silhouette || el.dataset.product || '_none')
      .toLowerCase()
      .trim();
  }

  function srcKey(el) {
    return el.dataset.product || el.getAttribute('src') || el.getAttribute('alt') || '';
  }

  /**
   * Misma lógica de variedad que el filtro TODOS del catálogo:
   * round-robin entre siluetas (Flare, Biker, Cargo…) — no alfabético.
   */
  function sortBySilhouetteVariety(list) {
    const buckets = new Map();
    list.forEach((el) => {
      const sil = silOf(el);
      if (!buckets.has(sil)) buckets.set(sil, []);
      buckets.get(sil).push(el);
    });

    const keys = [...buckets.keys()].sort((a, b) => {
      const ia = SIL_ORDER.indexOf(a);
      const ib = SIL_ORDER.indexOf(b);
      const sa = ia === -1 ? 999 : ia;
      const sb = ib === -1 ? 999 : ib;
      if (sa !== sb) return sa - sb;
      return 0;
    });

    // Mezcla ligera del orden de buckets para que no se sienta fijo, sin volver A–Z
    for (let i = keys.length - 1; i > 0; i -= 1) {
      if (Math.random() > 0.55) continue;
      const j = Math.floor(Math.random() * (i + 1));
      const t = keys[i];
      keys[i] = keys[j];
      keys[j] = t;
    }

    const out = [];
    let added = true;
    while (added) {
      added = false;
      keys.forEach((k) => {
        const bucket = buckets.get(k);
        if (bucket && bucket.length) {
          out.push(bucket.shift());
          added = true;
        }
      });
    }
    return out;
  }

  /**
   * Variedad tipo TODOS + ritmo mujer/hombre:
   * 1) Ordena dama y caballero por silueta (como el catálogo)
   * 2) Alterna géneros para no repetir el mismo tipo de modelo
   */
  function buildVarietyOrder(imgs) {
    const dama = sortBySilhouetteVariety(imgs.filter((el) => genderOf(el) === 'dama'));
    const cab = sortBySilhouetteVariety(imgs.filter((el) => genderOf(el) === 'caballero'));
    const other = sortBySilhouetteVariety(
      imgs.filter((el) => {
        const g = genderOf(el);
        return g !== 'dama' && g !== 'caballero';
      })
    );

    if (!dama.length && !cab.length) return sortBySilhouetteVariety(imgs);
    if (!dama.length) return cab.concat(other);
    if (!cab.length) return dama.concat(other);

    const out = [];
    let useCabFirst = Math.random() < 0.5;
    let di = 0;
    let ci = 0;
    while (di < dama.length || ci < cab.length) {
      if (useCabFirst) {
        if (ci < cab.length) out.push(cab[ci++]);
        if (di < dama.length) out.push(dama[di++]);
      } else {
        if (di < dama.length) out.push(dama[di++]);
        if (ci < cab.length) out.push(cab[ci++]);
      }
    }
    return out.concat(other);
  }

  function crossfade(fromEl, toEl) {
    if (!toEl || fromEl === toEl) return;
    // Crossfade profesional: ambas capas durante la transición
    toEl.style.zIndex = '2';
    toEl.classList.add('is-active');
    if (fromEl) {
      fromEl.style.zIndex = '1';
      // Espera a que el fade-in del nuevo avance antes de apagar el anterior
      window.setTimeout(() => {
        fromEl.classList.remove('is-active');
        fromEl.style.zIndex = '';
        toEl.style.zIndex = '';
      }, FADE_MS);
    }
  }

  function mount(root) {
    if (!root || root.dataset.rotateReady === '1') return;

    const media = root.querySelector('.category__media');
    if (!media) return;

    const imgs = [...media.querySelectorAll('img[data-rotate-src], .chikas-fit-img')]
      .filter((el) => el.tagName === 'IMG' && el.getAttribute('src'));

    if (imgs.length < 2) return;
    root.dataset.rotateReady = '1';
    media.classList.add('category__media--rotating');

    let order = buildVarietyOrder(imgs);
    // Una sola reorganización al inicio (no en cada tick → no corta el fade)
    order.forEach((el) => media.appendChild(el));

    let i = 0;
    order.forEach((el, n) => {
      el.classList.toggle('is-active', n === 0);
      el.style.zIndex = '';
    });

    if (root._chikasRotateTimer) window.clearInterval(root._chikasRotateTimer);

    root._chikasRotateTimer = window.setInterval(() => {
      if (!order.length) return;
      const prev = order[i];
      let nextIndex = (i + 1) % order.length;

      // Nuevo ciclo: rearmar variedad (como refrescar TODOS) sin cortar el fade
      if (nextIndex === 0) {
        const rebuilt = buildVarietyOrder(imgs);
        const lastKey = srcKey(prev);
        if (rebuilt.length > 1 && srcKey(rebuilt[0]) === lastKey) {
          const swapAt = rebuilt.findIndex((el, n) => n > 0 && srcKey(el) !== lastKey);
          if (swapAt > 0) {
            const t = rebuilt[0];
            rebuilt[0] = rebuilt[swapAt];
            rebuilt[swapAt] = t;
          }
        }
        // Reordenar DOM solo entre ciclos, tras el fade
        window.setTimeout(() => {
          rebuilt.forEach((el) => media.appendChild(el));
        }, FADE_MS + 40);
        order = rebuilt;
        nextIndex = 0;
      }

      const next = order[nextIndex];
      crossfade(prev, next);
      i = nextIndex;
    }, FORCE_MS);

    root.dataset.rotateMs = String(FORCE_MS);
  }

  function boot() {
    document.querySelectorAll('[data-chikas-rotate]').forEach((el) => {
      if (el.dataset.rotateReady === '1' && !el._chikasRotateTimer) {
        delete el.dataset.rotateReady;
      }
      mount(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const scope = e.target;
    const root = scope && scope.querySelector
      ? scope.querySelector('[data-chikas-rotate]')
      : null;
    if (root) {
      if (root._chikasRotateTimer) window.clearInterval(root._chikasRotateTimer);
      delete root.dataset.rotateReady;
    }
    boot();
  });
})();
